import { NEGATIVE_COLOR_CSS_VARIABLE } from "../../const";

const NEGATIVE_FILL = `var(${NEGATIVE_COLOR_CSS_VARIABLE}, #fff)`

const ArchimateIcons = () => (
  <>
    <svg
      viewBox="-8.00 -8.00 166.00 116.00"
      id="archimate-component-icon"
      data-label="Component"
      fill={NEGATIVE_FILL}
      stroke="currentColor"
      strokeWidth="6"
    >
      <path d="M 25,15 L 25,0 L 150,0 L 150,100 L 25,100 L 25,80"></path>
      <path d="M0 15 50 15 50 40 0 40 0 12M0 55 50 55 50 80 0 80 0 52M25 40 25 55"></path>
    </svg>

    <svg
      viewBox="-5.2 18 120.8 90"
      id="archimate-collaboration-icon"
      data-label="Collaboration"
      fill={NEGATIVE_FILL}
      stroke="currentColor"
      strokeWidth="20"
    >
      <path
        d="m 319.99974,252 a 140,140 0 1 1 0,-1.2e-4"
        transform="scale(0.24,0.25) translate(-20,0)"
      />
      <path
        d="m 459.99974,252 a 140,140 0 1 1 0,-1.2e-4"
        transform="scale(0.24,0.25) translate(-20,0)"
      />
      <path
        d="M 250.15625,131.53125 A 140,140 0 0 0 250.125,373.75 140,140 0 0 0 330.25,252.625 140,140 0 0 0 250.15625,131.53125 z"
        transform="scale(0.24,0.25) translate(-20,0)"
      />
    </svg>

    <svg
      viewBox="7.75 27.84 84 58"
      id="archimate-interface-icon"
      data-label="Interface"
      fill={NEGATIVE_FILL}
      stroke="currentColor"
      strokeWidth="6"
    >
      <path
        d="M 90 112.36218 L 50 112.36218 M 169.99993 112.4387 A 40 40 0 1 1 169.99993 112.43867"
        transform="matrix(.65 0 0 .65 -22.75 -16.25)"
      ></path>
    </svg>

    <svg
      viewBox="13 13.33 74 80"
      id="archimate-function-icon"
      data-label="Function"
      fill={NEGATIVE_FILL}
      stroke="currentColor"
      strokeWidth="10"
    >
      <path
        transform="scale(0.40,0.35) translate(-75, -90)"
        d="M 120,342.36218 L 120,222.36218 L 200,142.36218 L 280,222.36218 L 280,342.36218 L 200,262.36218 L 120,342.36218 z"
      />
    </svg>

    <svg
      viewBox="10 30.54 85 59"
      id="archimate-interaction-icon"
      data-label="Interaction"
      fill={NEGATIVE_FILL}
      stroke="currentColor"
      strokeWidth="7"
    >
      <path
        transform="translate(-102.5, -219) scale(0.62,0.62)"
        d="M240 492.36218 240 412.36218C240 412.36218 190 412.36218 190 452.36218 190 492.36218 240 492.36218 240 492.36218zM260 492.36218 260 412.36218C260 412.36218 310 412.36218 310 452.36218 310 492.36218 260 492.36218 260 492.36218z"
      ></path>
    </svg>

    <svg
      viewBox="7 18.94 92 56"
      id="archimate-process-icon"
      data-label="Process"
      fill={NEGATIVE_FILL}
      stroke="currentColor"
      strokeWidth="10"
    >
      <path
        transform="translate(-65, -142) scale(0.40,0.40)"
        d="M 320,492.36218 L 190,492.36218 L 190,452.36218 L 320,452.36218 L 320,412.36218 L 400,472.36218 L 320,532.36218 L 320,492.36218 z"
      ></path>
    </svg>

    <svg
      viewBox="15.5 32.18 79.5 58"
      id="archimate-event-icon"
      data-label="Event"
      fill={NEGATIVE_FILL}
      stroke="currentColor"
      strokeWidth="8"
    >
      <path
        transform="translate(-85, -170) scale(0.55, 0.50)"
        d="M 190,512.36218 C 190,512.36218 230,512.36218 230,462.36218 C 230,412.36218 190,412.36218 190,412.36218 L 280,412.36218 C 280,412.36218 320,412.36218 320,462.36218 C 320,512.36218 280,512.36218 280,512.36218 L 190,512.36218 z"
      ></path>
    </svg>

    <svg
      viewBox="-3.2 26.71 106.4 68"
      id="archimate-service-icon"
      data-label="Service"
      fill={NEGATIVE_FILL}
      stroke="currentColor"
      strokeWidth="20"
    >
      <path
        transform="translate(-31, -75) scale(0.27,0.30)"
        d="M 220,532.36218 C 220,532.36218 140,532.36218 140,452.36218 C 140,372.36218 220,372.36218 220,372.36218 L 380,372.36218 C 380,372.36218 460,372.36218 460,452.36218 C 460,532.36218 380,532.36218 380,532.36218 L 220,532.36218 z"
      ></path>
    </svg>

    <svg
      viewBox="3.60 3.60 88.80 88.80"
      id="archimate-driver-icon"
      data-label="Driver"
      fill="none"
      stroke="currentColor"
      strokeWidth=".4"
    >
      <g transform="scale(8, 8)">
        <circle strokeWidth="1.05" cx="6" cy="6" r="4"></circle>
        <circle fill="currentColor" cx="6" cy="6" r="1"></circle>
        <path d="M2 2 10 10M2 10 10 2M.5 6 11.5 6M6 .5 6 11.5"></path>
      </g>
    </svg>

    <svg
      viewBox="7.5 9.06 72.5 77"
      id="archimate-assessment-icon"
      data-label="Assessment"
      fill="none"
      stroke="currentColor"
      strokeWidth="8"
    >
      <path
        transform="translate(-125, -30) scale(0.45,0.45)"
        d="M440 152.36218a50 50 0 1 1-100 0 50 50 0 1 1 100 0zM356 188.36218c-46 54-46 54-46 54"
      ></path>
    </svg>

    <svg
      viewBox="3.24 28.4 96 63.6"
      id="archimate-role-icon"
      data-label="Role"
      fill={NEGATIVE_FILL}
      stroke="currentColor"
      strokeWidth="12"
    >
      <g transform="scale(0.42, 0.43) translate(-518, -400)">
        <path d="M 710.00 480.00l -140.00 0.00a 30.00 60.00 0 0 0 0.00 120.00l 140.00 0.00"></path>
        <ellipse ry="60" rx="30" cy="540" cx="710"></ellipse>
      </g>
    </svg>

    <svg
      viewBox="15.00 5.34 71.00 98.08"
      id="archimate-actor-icon"
      data-label="Actor"
      fill={NEGATIVE_FILL}
      stroke="currentColor"
      strokeWidth="13"
    >
      <path
        fill="currentColor"
        d="m 280,332.36218 c 6.35627,1.86577 3.05771,2.03469 10,0 l 0,15 70,0 0,5 -70,0 0,45 70,80 -5,5 -70,-80 -70,80 -5,-5 70,-80 0,-45 -70,0 0,-5 70,0 0,-15 z"
        transform="translate(-35, -35) scale(0.30,0.26)"
      ></path>
      <path
        d="M 343.87939,263.93616 A 59.192352,58.789684 0 1 1 225.49469,263.93616 A 59.192352,58.789684 0 1 1 343.87939,263.93616 z"
        transform="translate(-35, -35) scale(0.30,0.26)"
      ></path>
    </svg>

    <svg
      viewBox="11.51 42.24 71.16 47.36"
      id="archimate-plateau-icon"
      data-label="Plateau"
      fill={NEGATIVE_FILL}
      stroke="currentColor"
    >
      <g
        fill="currentColor"
        stroke="none"
        transform="translate(-30, 10) scale(0.26, 0.24)"
      >
        <path d="M222.384 134.314H433.364V171.378H222.384z"></path>
        <path d="M193.874 214.165H404.854V251.22899999999998H193.874z"></path>
        <path d="M159.661 294.591H370.64099999999996V331.65500000000003H159.661z"></path>
      </g>
    </svg>

    <svg
      viewBox="-1 32.8 92 60"
      id="archimate-gap-icon"
      data-label="Gap"
      fill={NEGATIVE_FILL}
      stroke="currentColor"
      strokeWidth="12"
    >
      <path
        transform="translate(5, -110) scale(0.4,0.4)"
        d="M160 432a60 60 0 1 1-120 0 60 60 0 1 1 120 0zM0 412h200M0 452h200"
      ></path>
    </svg>

    <svg
      viewBox="12.80 26.94 74.80 64.00"
      id="archimate-device-icon"
      data-label="Device"
      fill={NEGATIVE_FILL}
      stroke="currentColor"
      strokeWidth="8"
    >
      <path
        d="M240 502.36218 240 422.36218C240 417.36218 245 412.36218 250 412.36218L370 412.36218C375 412.36218 380 417.36218 380 422.36218L380 502.36218C380 507.36218 375 512.36218 370 512.36218L250 512.36218C245 512.36218 240 507.36218 240 502.36218zM240 532.36218 270 512.36218 350 512.36218 380 532.36218 240 532.36218z"
        transform="translate(-80, -130) scale(0.42,0.4)"
      ></path>
    </svg>

    <svg
      viewBox="-5.12 -7.03 105.73 105.05"
      id="archimate-equipment-icon"
      data-label="Equipment"
      fill={NEGATIVE_FILL}
      stroke="currentColor"
      strokeWidth="13"
    >
      <g
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="translate(-50, -90) scale(0.25,0.25)"
      >
        <path
          id="path3010"
          d="m 322.12664,698.36306 c -12.60017,-2.67104 -22.63853,-5.86829 -23.22528,-7.39733 -0.43957,-1.1455 1.33508,-14.16871 3.16201,-23.20438 0.59335,-2.93461 0.32608,-3.27064 -4.98574,-6.26845 -3.08699,-1.74219 -7.4154,-4.79624 -9.61869,-6.78678 l -4.00598,-3.61917 -12.22648,5.15674 c -6.72457,2.8362 -13.01628,5.14813 -13.98159,5.13761 C 254.17057,661.34781 238.5,637.78628 238.5,633.19736 c 0,-0.75479 5.10607,-4.82205 11.34682,-9.03835 l 11.34681,-7.666 -1.29703,-6.81541 c -0.71336,-3.74848 -1.65693,-9.02234 -2.09681,-11.71968 L 257,593.05367 244.25,588.57345 c -12.66159,-4.44916 -12.74985,-4.50183 -12.72836,-7.59575 0.0332,-4.78371 3.60161,-19.86898 6.04167,-25.54104 2.56829,-5.97015 1.7538,-5.83815 18.8309,-3.05183 6.81682,1.11224 12.46003,1.89965 12.54045,1.7498 1.20422,-2.24358 6.87849,-9.32893 10.43841,-13.03423 l 4.57496,-4.76178 -5.72402,-11.49924 C 275.07581,518.51479 272.5,512.77902 272.5,512.09321 c 0,-3.00727 24.66668,-16.73103 30.07187,-16.73103 2.15798,0 4.02811,1.83415 10.45104,10.25 4.30251,5.6375 7.91523,10.38276 8.02828,10.54503 0.11304,0.16226 2.17277,-0.19808 4.57717,-0.80076 2.4044,-0.60268 8.11019,-1.41044 12.67952,-1.79503 l 8.30789,-0.69924 4.71959,-12 c 3.95137,-10.04673 5.09327,-12.05358 7.01529,-12.32914 4.82944,-0.69241 32.14555,6.35103 33.52302,8.64388 0.22642,0.37689 -0.58432,6.5909 -1.80165,13.8089 l -2.21332,13.12364 5.49575,3.28715 c 3.02266,1.80794 7.20294,4.8295 9.28951,6.71459 l 3.79377,3.42744 11.85667,-5.08823 c 6.52117,-2.79853 12.76544,-5.08823 13.87615,-5.08823 2.40528,0 3.51823,1.18072 10.36868,11 2.87782,4.125 4.98215,6.76917 4.67629,5.87593 -0.30586,-0.89324 -0.86882,-5.20895 -1.25102,-9.59048 l -0.69492,-7.96641 -4.63479,-1.20163 c -2.54913,-0.6609 -6.42838,-1.99991 -8.62055,-2.97559 l -3.98576,-1.77395 -7.98756,6.31607 c -4.39315,3.47383 -8.44956,6.31309 -9.01424,6.30947 C 408.08491,533.33671 390.5,517.38247 390.5,514.73237 c 0,-0.69424 2.92753,-4.60561 6.50562,-8.69194 l 6.50561,-7.4297 -3.07784,-6.87428 c -1.69282,-3.78085 -3.43035,-7.54927 -3.86119,-8.37427 -0.55973,-1.07182 -3.70172,-1.78545 -11.00712,-2.5 -7.30038,-0.71406 -10.44937,-1.42891 -11.01268,-2.5 -2.04548,-3.88924 -1.96155,-23.42418 0.10953,-25.49526 0.24977,-0.24977 5.33615,-1.02801 11.30307,-1.72943 l 10.84895,-1.27531 1.74134,-5.12998 c 0.95773,-2.82149 2.50743,-6.2992 3.44377,-7.72824 l 1.70244,-2.59826 -7.20164,-7.9757 -7.20165,-7.9757 2.02154,-2.79606 c 4.10095,-5.67217 16.27874,-16.29606 18.6796,-16.29606 0.67629,0 4.93479,2.85889 9.46333,6.3531 l 8.23371,6.3531 7.6518,-3.34089 c 4.2085,-1.83749 8.15077,-3.34639 8.76062,-3.3531 0.66153,-0.007 1.57592,-4.12011 2.26678,-10.19566 0.63689,-5.6009 1.41293,-10.4384 1.72453,-10.75 0.3116,-0.3116 6.62046,-0.56655 14.01969,-0.56655 10.43321,0 13.64678,0.31332 14.31578,1.39578 0.47445,0.76768 1.1576,4.36768 1.51811,8 1.22824,12.37522 1.32519,12.62408 5.37266,13.79038 2.0205,0.58223 5.71938,1.85408 8.21972,2.82634 l 4.54609,1.76774 7.95391,-6.1347 c 4.37466,-3.37409 8.58257,-6.13714 9.35093,-6.14012 3.02797,-0.0117 20.10299,15.83906 20.10299,18.66168 0,0.84358 -2.98772,4.87204 -6.63938,8.95213 l -6.63938,7.41834 3.13938,6.81097 c 1.72666,3.74604 3.13938,7.29719 3.13938,7.89145 0,0.64222 3.54911,1.34359 8.75,1.72916 13.73613,1.01835 13.91399,1.08325 14.61669,5.33344 0.78491,4.74746 0.78613,15.64001 0.002,20.38067 l -0.609,3.68326 -6.62999,0.60902 c -3.6465,0.33496 -8.65499,0.85084 -11.12999,1.1464 l -4.5,0.53738 -3.16542,7.49349 -3.16542,7.49349 6.91542,7.58628 c 3.80377,4.17246 6.91571,8.06569 6.91571,8.65163 0,1.90704 -17.72709,18.61579 -19.75035,18.61579 -1.0712,0 -5.64143,-2.74986 -10.15607,-6.11079 l -8.20843,-6.1108 -5.69257,2.49365 c -3.13092,1.3715 -6.89029,2.76994 -8.35415,3.10765 -2.8981,0.66857 -3.13937,1.47992 -4.42506,14.88076 -0.78641,8.19683 -0.27527,7.97703 -17.55617,7.5495 l -12.52882,-0.30997 1.83207,3 c 1.00764,1.65 1.81978,3.675 1.80475,4.5 -0.015,0.825 -5.2304,5.04193 -11.58971,9.37096 -10.65869,7.25578 -11.51838,8.07645 -10.99916,10.5 0.30978,1.44597 1.11439,6.47901 1.78803,11.18453 l 1.22481,8.55549 12.87506,4.40269 c 7.08129,2.42149 13.09006,4.75056 13.35283,5.17573 1.62944,2.63649 -6.75452,31.54238 -9.4485,32.57616 -1.26311,0.4847 -23.1257,-2.20595 -27.2515,-3.35387 -0.97124,-0.27023 -2.01091,0.49887 -2.69043,1.99026 -0.60912,1.33688 -3.59648,5.36468 -6.63857,8.95067 l -5.53107,6.51998 5.57049,11.58455 c 3.06377,6.3715 5.32875,12.21452 5.03329,12.98448 -0.8447,2.20127 -12.09736,9.42729 -21.30489,13.68118 -4.61568,2.13246 -8.76653,3.87719 -9.2241,3.87719 -0.45757,0 -4.34553,-4.6125 -8.63991,-10.25 -4.29438,-5.6375 -8.10963,-10.60029 -8.47834,-11.02842 -0.3687,-0.42813 -3.56008,-0.0973 -7.09195,0.73522 -3.53187,0.8325 -9.05121,1.52029 -12.2652,1.52842 -4.71371,0.0119 -5.9336,0.35316 -6.30897,1.76478 -1.52769,5.74501 -10.06804,23.75366 -11.34741,23.92776 -0.825,0.11227 -5.49301,-0.64233 -10.37336,-1.67688 z"
        ></path>
        <path
          id="path3006"
          d="m 337.01941,640.29447 c -11.99208,-2.00438 -24.44334,-8.52601 -31.09687,-16.28769 -1.95408,-2.27953 -5.17376,-7.42081 -7.15484,-11.42507 -10.80127,-21.83203 -0.84959,-48.95782 22.09846,-60.23488 16.53861,-8.12735 32.57288,-8.05988 49.63384,0.20887 16.36297,7.93046 27.51132,27.66222 25.53381,45.19295 -0.70333,6.2351 -3.65513,15.11549 -6.68374,20.10778 -3.60571,5.94358 -12.28948,13.61376 -19.34022,17.08278 -11.18497,5.5031 -21.79833,7.22594 -32.99044,5.35526 z"
        ></path>
        <path
          id="path3000"
          d="m 450.5,502.98834 c -7.77404,-2.1402 -12.30656,-4.84208 -18.58751,-11.08018 -7.91018,-7.85622 -10.69987,-14.64697 -10.69987,-26.04598 0,-10.09289 2.69279,-17.51013 8.83863,-24.34578 9.47846,-10.54233 20.00183,-14.71164 35.13442,-13.92011 7.87499,0.41191 10.30909,0.98106 15.83926,3.70355 13.17782,6.48742 21.39478,18.13075 22.25502,31.53512 0.6144,9.57372 -1.0777,16.24768 -5.98108,23.59056 -9.53011,14.27144 -29.47796,21.33129 -46.79887,16.56282 z"
        ></path>
      </g>
    </svg>

    <svg
      viewBox="-8.60 8.40 152.40 139.20"
      id="archimate-facility-icon"
      data-label="Facility"
      fill={NEGATIVE_FILL}
      stroke="currentColor"
      strokeWidth="40"
    >
      <path
        d="m 86.980304,500 0,-248.00001 39.999986,0 40,0 0,161.50001 c 0,88.825 0.15497,161.5 0.34437,161.5 0.1894,0 35.75678,-19.5958 79.03862,-43.5462 43.28184,-23.9504 79.35187,-43.7986 80.15563,-44.107 1.26838,-0.4867 1.46138,5.3303 1.46138,44.0462 0,24.5339 0.25115,44.607 0.55811,44.607 0.44829,0 144.34899,-79.2998 156.18162,-86.0675 l 3.23974,-1.8529 0.26026,44.3367 0.26027,44.3368 73,-40.4326 c 40.15,-22.2379 76.2625,-42.2388 80.25,-44.4466 l 7.25,-4.014 0,130.07 0,130.07012 -281,0 -280.999986,0 0,-248.00002 z"
        transform="scale(0.2,0.2) translate(-30, -110)"
      ></path>
    </svg>

    <svg
      viewBox="4.5 30.9 93 58.6"
      id="archimate-stakeholder-icon"
      data-label="Stakeholder"
      fill={NEGATIVE_FILL}
      stroke="currentColor"
      strokeWidth="13"
    >
      <g transform="translate(-205, -145) scale(0.40,0.38)">
        <path d="M 710.00 480.00l -140.00 0.00a 30.00 60.00 0 0 0 0.00 120.00l 140.00 0.00"></path>
        <ellipse ry="60" rx="30" cy="540" cx="710"></ellipse>
      </g>
    </svg>

    <svg
      viewBox="6.5 5.92 79 79"
      id="archimate-capability-icon"
      data-label="Capability"
      fill={NEGATIVE_FILL}
      stroke="currentColor"
      strokeWidth="7"
    >
      <path
        transform="translate(-80, -70) scale(0.6,0.6)"
        d="m 150,212.36218 40,0 0,-40 40,0 0,-40 40,0 0,120.0 -120,0 z"
      ></path>
      <path
        transform="translate(-80, -70) scale(0.6,0.6)"
        d="m190 212.36218 80 0M230 172.36218l40 0M190 212.36218l0 40M230 172.36218l0 80"
        fill="none"
      ></path>
    </svg>

    <svg
      viewBox="7 13.38 76 76"
      id="archimate-goal-icon"
      data-label="Goal"
      fill="none"
      stroke="currentColor"
      strokeWidth="4"
    >
      <path
        transform="translate(-135, -160) scale(0.6, 0.6)"
        d="M 360,352.3 A 60,60 0 1 1 360,352.28413"
      ></path>
      <path
        transform="translate(-135, -160) scale(0.6, 0.6)"
        d="M 340,352.315 A 40,40 0 1 1 340,352.31015"
      ></path>
      <path
        transform="translate(-135, -160) scale(0.6, 0.6)"
        d="m 320,352.353 A 20,20 0 1 1 320,352.33617"
        fill="currentColor"
      ></path>
    </svg>

    <svg
      viewBox="5.00 0 91.45 91.45"
      id="archimate-outcome-icon"
      data-label="Outcome"
      fill={NEGATIVE_FILL}
      stroke="currentColor"
    >
      <g stroke="currentColor" transform="translate(-110, -120) scale(0.5,0.5)">
        <path
          id="path4"
          fill="none"
          strokeWidth="4"
          d="M 360,352.36218 A 60,60 0 1 1 359.99995,352.28413"
        ></path>
        <path
          id="path6"
          fill="none"
          strokeWidth="4"
          d="M 340,352.36218 A 40,40 0 1 1 339.99997,352.31015"
        ></path>
        <path
          id="path8"
          fill="none"
          strokeWidth="4"
          d="m 320,352.36218 a 20,20 0 1 1 -2e-5,-0.026"
        ></path>
        <path
          id="path3761"
          fill="none"
          strokeDasharray="none"
          strokeLinecap="round"
          strokeLinejoin="miter"
          strokeMiterlimit="4"
          strokeOpacity="1"
          strokeWidth="15"
          d="m 378.41315,273.35811 -70.34336,72.89506"
        ></path>
        <path
          id="path2991"
          fill="none"
          strokeDasharray="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="4"
          strokeOpacity="1"
          strokeWidth="9.915"
          d="m 401.07359,282.27089 -49.56986,17.55663 11.12793,-48.53893"
        ></path>
        <path
          id="path3762"
          fill="currentColor"
          fillOpacity="1"
          strokeDasharray="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="4"
          strokeOpacity="1"
          strokeWidth="9.256"
          d="m 297.38061,352.98157 36.82641,-6.57708 -29.07348,-28.18748 z"
        ></path>
      </g>
    </svg>

    <svg
      viewBox="1.80 34.00 96.00 51.40"
      id="archimate-constraint-icon"
      data-label="Constraint"
      fill={NEGATIVE_FILL}
      stroke="currentColor"
      strokeWidth="4"
    >
      <path
        d="m1 1 90 0 20-30-90 0zM40-30l-20 30"
        transform="translate(5, 80) scale(0.8, 1.4)"
      ></path>
    </svg>

    <svg
      viewBox="-2.50 2.92 95.00 95.00"
      id="archimate-principle-icon"
      data-label="Principle"
      fill={NEGATIVE_FILL}
      stroke="currentColor"
      strokeWidth="10"
    >
      <path
        d="M 120,112.36218 c 10,-10 100,-10 110,0 10,10 10,100 0,110 -10,10 -100,10 -110,0 -10,-10 -10,-100 0,-110 z"
        transform="translate(-60, -50) scale(0.6, 0.6)"
      ></path>
      <path
        fill="currentColor"
        stroke="none"
        d="m173.28742 177.58938-2.81445-34.88802 0-14.59282 11.41127 0 0 14.59282-2.66092 34.88802-5.9359 0zM170.88234 205.93332l0-9.20469 10.59253 0 0 9.20469-10.59253 0z"
        transform="translate(-60, -50) scale(0.6, 0.6)"
      ></path>
    </svg>

    <svg
      viewBox="1.60 44.00 96.00 44.00"
      id="archimate-requirement-icon"
      data-label="Requirement"
      fill={NEGATIVE_FILL}
      stroke="currentColor"
      strokeWidth="4"
    >
      <path
        d="M 0,0 l 90,0 l 20,-30 l -90,0 z"
        transform="scale(0.8,1.2) translate(7, 70)"
      ></path>
    </svg>

    <svg
      viewBox="0.28 12.82 100.31 75.13"
      id="archimate-course-of-action-icon"
      data-label="Course of Action"
      fill={NEGATIVE_FILL}
      stroke="currentColor"
      strokeWidth="14"
    >
      <g transform="translate(-2,-25) scale(0.13,0.13)">
        <path
          d="m 608.95033,658.83828 c 59.06716,-15.80533 101.89042,-55.18975 118.88385,-109.33709 7.1632,-22.82456 9.21231,-45.61047 5.90996,-65.71828 -9.08886,-55.34189 -43.56494,-99.34835 -96.25031,-122.85727 -27.53448,-12.28623 -45.38319,-16.06026 -76.28163,-16.12939 -30.7768,-0.0689 -48.26893,3.62976 -76.28162,16.12939 -36.01592,16.07078 -62.13383,40.1874 -79.53826,73.44355 -13.53688,25.8662 -17.54245,42.01796 -17.46789,70.43647 0.0749,28.53081 4.16208,45.01184 17.46789,70.43646 36.81382,70.3435 122.13637,105.38328 203.55801,83.59616 z"
          stroke="currentColor"
          fill="none"
          id="path3027"
        ></path>
        <path
          d="m 130.63565,786.58651 c 29.03371,-38.23001 61.87763,-69.67683 97.12311,-92.99171 17.41325,-11.51886 28.09341,-17.35217 29.30023,-16.00325 0.52141,0.58281 0.34566,11.76523 -0.42427,26.99496 -0.72293,14.3 -1.04732,27.35 -0.72085,29 1.82827,9.24039 12.76303,14.29994 21.07182,9.75 4.46026,-2.44247 113.966,-127.5772 116.47825,-133.10238 3.18653,-7.00814 0.33326,-15.27813 -6.33712,-18.36769 -4.26039,-1.97331 -172.36675,-25.03309 -175.86806,-24.12449 -3.75017,0.97319 -7.84703,4.14806 -9.51509,7.37374 -1.7799,3.44196 -1.88509,10.63156 -0.19947,13.63479 0.66801,1.19018 9.87706,11.20964 20.46456,22.26548 10.5875,11.05583 19.24801,20.65705 19.24557,21.33603 -0.002,0.67899 -5.06667,3.79709 -11.25385,6.92912 -11.265,5.70248 -33.8729,20.00251 -45.20655,28.5942 -30.1752,22.87489 -61.35361,53.75908 -86.070957,85.25871 -8.4339,10.74811 -27.96049,38.86626 -27.31809,39.33785 0.19464,0.14289 2.60388,1.08056 5.35388,2.08371 10.69716,3.90217 21.55901,10.14436 29.887567,17.17606 l 3.88756,3.28223 7.01309,-10.21368 c 3.8572,-5.61752 9.7471,-13.81368 13.08867,-18.21368 z"
          fill="currentColor"
          id="path3015"
        ></path>
        <path
          transform="translate(-3.6589529,-3.0634694)"
          d="m 607.38617,508.09293 a 39.333744,39.333744 0 1 1 -78.66748,0 39.333744,39.333744 0 1 1 78.66748,0 z"
          strokeOpacity="1"
          strokeMiterlimit="4"
          strokeLinejoin="round"
          strokeLinecap="round"
          strokeDashoffset="0"
          strokeDasharray="none"
          stroke="currentColor"
          fillOpacity="1"
          fill="currentColor"
          id="path3756"
        ></path>
        <path
          d="m 590.38847,598.30823 c 34.89648,-9.67474 60.19617,-33.78265 70.23577,-66.92722 4.23197,-13.97132 5.44257,-27.91899 3.49157,-40.22734 -5.36964,-33.87577 -25.73787,-60.81292 -56.86403,-75.20315 -16.26718,-7.52063 -26.81208,-9.83078 -45.06667,-9.87309 -18.18272,-0.0422 -28.51695,2.22184 -45.06666,9.87309 -21.27796,9.83721 -36.70824,24.59943 -46.99066,44.95612 -7.9975,15.83316 -10.36396,25.71995 -10.31991,43.11543 0.0442,17.46423 2.45893,27.55256 9.31991,43.11543 21.74935,43.05853 72.15733,64.50701 120.26068,51.17073 z"
          stroke="currentColor"
          fill="none"
          id="path3027-1"
        ></path>
      </g>
    </svg>

    <svg
      viewBox="20.98 18.78 65.23 44.82"
      id="archimate-value-stream-icon"
      data-label="Value Stream"
      fill={NEGATIVE_FILL}
      stroke="currentColor"
      strokeWidth="4"
    >
      <path
        d="M 31.516067 39.755906 L 52.44882 62.43307 L 31.516065 85.11024 L -15.582679 85.11023 L 5.3502197 62.43308 L -15.582677 39.755903 Z"
        transform="translate(40, -10) scale(0.8, 0.8)"
      ></path>
    </svg>

    <svg
      viewBox="20.50 19.25 49.00 64.00"
      id="archimate-artifact-icon"
      data-label="Artifact"
      fill={NEGATIVE_FILL}
      stroke="currentColor"
      strokeWidth="2"
    >
      <path
        strokeLinejoin="bevel"
        d="M 65.00 54.17 L 65.00 74.17 L 35.00 74.17 L 35.00 34.17 L 50.00 34.17 L 65.00 54.17 L 50.00 54.17 L 50.00 34.17 z"
        transform="scale(1.25, 1.25) translate(-14,-14)"
      ></path>
    </svg>

    <svg
      viewBox="3.8 7.68 86.6 80"
      id="archimate-node-icon"
      data-label="Node"
      fill={NEGATIVE_FILL}
      stroke="currentColor"
      strokeWidth="14"
    >
      <path
        transform="translate(-42, -95) scale(0.33,0.33)"
        d="M 220,332.36218 L 160,372.36218 L 160,532.36218 L 320,532.36218 L 380,492.36218 L 380,332.36218 L 220,332.36218 z"
      ></path>
      <path
        transform="translate(-42, -95) scale(0.33,0.33)"
        d="M160 372.36218 320 372.36218 320 532.36218M320 372.36218 380 332.36218"
      ></path>
    </svg>

    <svg
      viewBox="0.64 24.97 99.03 58.57"
      id="archimate-distribution-network-icon"
      data-label="Distribution Network"
      fill={NEGATIVE_FILL}
      stroke="currentColor"
      strokeWidth="4"
    >
      <g strokeOpacity="1" transform="translate(-135, -440) scale(0.57,1.25)">
        <path
          id="path3757"
          strokeLinecap="butt"
          strokeLinejoin="round"
          d="m 244.9752,395.47191 20.06623,-9.47572 117.61039,0 22.01711,10.31182 -18.39404,8.36092 -121.23346,-0.55739 z"
        ></path>
        <path
          id="path3032"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="4"
          d="m 265.25483,385.8172 21.67759,-10.64172"
        ></path>
        <path
          id="path3759"
          strokeLinecap="round"
          strokeLinejoin="miter"
          d="m 265.25483,404.20233 20.10104,9.45931"
        ></path>
        <path
          id="path3763"
          strokeLinecap="round"
          strokeLinejoin="miter"
          d="M 386.22138,404.59647 362.5731,415.63233"
        ></path>
        <path
          id="path3765"
          strokeLinecap="round"
          strokeLinejoin="miter"
          d="m 382.87121,386.03818 -18.91863,-9.45931"
        ></path>
      </g>
    </svg>

    <svg
      viewBox="-22.04 -50.88 214.19 265.56"
      id="archimate-location-icon"
      data-label="Location"
      fill={NEGATIVE_FILL}
      stroke="currentColor"
      strokeWidth="60"
    >
      <path
        d="m702.026917,1819.715942c-38.765869,-192.436157 -107.115967,-352.576904 -189.902954,-500.998535c-61.406982,-110.093628 -132.543945,-211.712036 -198.364014,-318.471436c-21.971985,-35.639465 -40.93396,-73.290222 -62.047012,-110.277649c-42.215942,-73.95752 -76.44397,-159.70697 -74.268982,-270.93811c2.125,-108.678802 33.208008,-195.857086 78.029968,-267.135925c73.71907,-117.235718 197.201065,-213.356186 362.884048,-238.616455c135.466064,-20.653145 262.475098,14.239998 352.542969,67.496887c73.600159,43.520874 130.59613,101.654877 173.920105,170.16803c45.219971,71.509399 76.359009,155.990753 78.970947,266.185364c1.337036,56.456421 -7.804932,108.738464 -20.68396,152.105591c-13.033936,43.896118 -33.995972,80.589172 -52.645996,119.783081c-36.406006,76.507874 -82.04895,146.608582 -127.855042,216.750793c-136.437012,208.924072 -264.496094,421.992065 -320.580078,713.948364z"
        transform="translate(22, 0) scale(0.09, 0.085)"
      ></path>
    </svg>

    <svg
      viewBox="6.70 12.47 87.03 75.68"
      id="archimate-material-icon"
      data-label="Material"
      fill={NEGATIVE_FILL}
      stroke="currentColor"
      strokeWidth="2.25"
    >
      <g transform="translate(-63, -17) scale(2,2)">
        <path
          id="path3762"
          strokeLinecap="butt"
          strokeLinejoin="miter"
          d="m 38.565022,32.631241 8.96861,-15.246637 18.385648,-0.224215 8.7444,15.470852 -9.19283,15.470852 -17.488787,0.224215 z"
        ></path>
        <path
          id="path3039"
          strokeLinejoin="round"
          d="M 45.009743,34.403462 52.500929,21.41096"
        ></path>
        <path
          id="path3031"
          strokeLinejoin="round"
          d="m 49.306872,42.396261 14.919507,-0.05362"
        ></path>
        <path
          id="path3027"
          strokeLinejoin="round"
          d="m 61.038685,21.427553 7.428321,12.938879"
        ></path>
      </g>
    </svg>

    <svg
      viewBox="7.15 23.21 83.65 59.50"
      id="archimate-resource-icon"
      data-label="Resource"
      fill={NEGATIVE_FILL}
      stroke="currentColor"
      strokeWidth="5"
    >
      <g strokeOpacity="1" transform="translate(-220, -475) scale(0.5,0.6)">
        <path
          id="path3027"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m 470.03755,921.81722 c -1.85469,-0.50698 -4.35439,-2.10156 -5.5549,-3.54349 -2.1124,-2.53725 -2.18271,-3.77229 -2.18271,-38.34014 0,-34.51561 0.0732,-35.80633 2.17289,-38.32833 1.19508,-1.43544 3.95313,-3.0628 6.12899,-3.61635 5.79609,-1.47457 114.9239,-1.19431 119.62622,0.30722 6.28175,2.00589 7.9835,5.39306 8.39834,16.71613 l 0.36366,9.9263 5.55629,0 c 8.36804,0 9.05848,1.15618 9.05848,15.16872 0,13.73959 -0.6818,14.82134 -9.34147,14.82134 l -5.47159,0 -0.002,8.7471 c -0.002,10.45258 -1.87784,14.88399 -7.40489,17.49265 -3.39581,1.60275 -8.44686,1.7405 -60.83937,1.65926 -31.42486,-0.0488 -58.65359,-0.50342 -60.50829,-1.01041 z"
        ></path>
        <path
          id="path3801"
          strokeLinecap="butt"
          strokeLinejoin="miter"
          d="m 599.54079,864.9759 -0.30211,29.90937"
        ></path>
        <path
          id="path2991"
          strokeLinecap="butt"
          strokeLinejoin="miter"
          d="m 490.2596,857.04923 0,45.76271"
        ></path>
        <path
          id="path2991-1"
          strokeLinecap="butt"
          strokeLinejoin="miter"
          d="m 514.55697,857.04923 0,45.76271"
        ></path>
        <path
          id="path2991-7"
          strokeLinecap="butt"
          strokeLinejoin="miter"
          d="m 538.6076,857.04923 0,45.76271"
        ></path>
      </g>
    </svg>

    <svg
      viewBox="7.00 10.47 73.81 74.83"
      id="archimate-system-software-icon"
      data-label="System Software"
      fill={NEGATIVE_FILL}
      stroke="currentColor"
      strokeWidth="3"
    >
      <path
        d="m 198.78192,335.7091 c 2.25058,-5.5074 7.75124,-8.91435 13.25734,-10.52162 7.7349,-1.8549 16.81379,0.90707 21.20183,7.79004 3.78502,5.58344 5.01688,13.05846 2.31444,19.35716 -1.38821,3.54796 -3.77522,6.91075 -7.30707,8.56565"
        transform="translate(-255, -440) scale(1.4, 1.4)"
      ></path>
      <path
        d="m 230,352.36218 c 0,11.0457 -8.95431,20 -20,20 -11.04569,0 -20,-8.9543 -20,-20 0,-11.04569 8.95431,-20 20,-20 11.04569,0 20,8.95431 20,20 z"
        transform="translate(-255, -440) scale(1.4, 1.4)"
      ></path>
    </svg>

    <svg
      viewBox="-9.00 6.06 116.00 94.00"
      id="archimate-path-icon"
      data-label="Path"
      fill={NEGATIVE_FILL}
      stroke="currentColor"
    >
      <g strokeWidth="20">
        <path
          fill="none"
          d="M550 102.36218c0 0-60 50-60 60 0 10 60 60 60 60M620 102.36218c0 0 60 50 60 60 0 10-60 60-60 60"
          transform="translate(-185, -20) scale(0.4, 0.45)"
        ></path>
        <path
          d="M540 162.36218c30 0 30 0 30 0M600 162.36218c30 0 30 0 30 0"
          transform="translate(-185, -20) scale(0.4, 0.45)"
        ></path>
      </g>
    </svg>

    <svg
      viewBox="7.84 15.91 84.42 71.65"
      id="archimate-communication-network-icon"
      data-label="Network"
      fill="none"
      stroke="currentColor"
    >
      <g transform="translate(0, 15) scale(0.15,0.15)">
        <path
          id="path3765"
          strokeLinecap="butt"
          strokeLinejoin="miter"
          strokeWidth="4"
          d="M 105.62897,396.51664 397.29105,402.82287 554.94622,93.818703 253.82484,89.089053 z"
        ></path>
        <path
          id="path4"
          fill="currentColor"
          d="m 213.7429,399.7652 a 77.394157,77.394157 0 1 1 0,-0.0774"
        ></path>
        <path
          id="path6"
          fill="currentColor"
          d="m 298.87647,90.188585 a 77.394157,77.394157 0 1 1 0,-0.07739"
        ></path>
        <path
          id="path8"
          fill="currentColor"
          d="m 608.4531,90.188585 a 77.394157,77.394157 0 1 1 0,-0.07739"
        ></path>
        <path
          id="path10"
          fill="currentColor"
          d="m 523.31952,399.7652 a 77.394157,77.394157 0 1 1 0,-0.0774"
        ></path>
      </g>
    </svg>

    <svg
      viewBox="2.5 31.3 95 56.2"
      id="archimate-object-icon"
      data-label="Object"
      fill={NEGATIVE_FILL}
      stroke="currentColor"
      strokeWidth="10"
    >
      <g transform="scale(0.25, 0.33) translate(30, 110)">
        <path d="M0 0H340V140H0z" />
        <path d="M 340.00 5 v 25.00 h -340.00" />
      </g>
    </svg>

    <svg
      viewBox="2.5 31.3 95 55.21"
      id="archimate-contract-icon"
      data-label="Contract"
      fill={NEGATIVE_FILL}
      stroke="currentColor"
      strokeWidth="10"
    >
      <g transform="scale(0.25, 0.33) translate(30, 110)">
        <path d="M0 0H340V137H0z"></path>
        <path d="M340 5v25h-340M340 107v0h-340"></path>
      </g>
    </svg>

    <svg
      viewBox="2.5 31.3 95 56.2"
      id="archimate-product-icon"
      data-label="Product"
      fill={NEGATIVE_FILL}
      stroke="currentColor"
      strokeWidth="10"
    >
      <g transform="scale(0.25, 0.33) translate(30, 110)">
        <path d="M0 0H340V140H0z"></path>
        <path d="M 170.00 5 v 25.00 h -170.00"></path>
      </g>
    </svg>

    <svg
      viewBox="7 30.2 91.6 59.91"
      id="archimate-representation-icon"
      data-label="Representation"
      fill={NEGATIVE_FILL}
      stroke="currentColor"
      strokeWidth="10"
    >
      <path
        transform="scale(0.24, 0.32) translate(50, 110)"
        d="M0 0h340v130c-170-90-170 90-340 0v-130zM0 30h340"
      ></path>
    </svg>

    <svg
      viewBox="1.3 29.8 94 55.23"
      id="archimate-wave-icon"
      data-label="Wave"
      fill={NEGATIVE_FILL}
      stroke="currentColor"
      strokeWidth="10"
    >
      <path
        transform="scale(0.21, 0.29) translate(30, 120)"
        d="M 0 0 h 400.00 v 130.00 c -200.00,-90.00 -200.00,90.00 -400.00,0.00 v -130.00 z"
      ></path>
    </svg>

    <svg
      viewBox="-0.6 28.6 98 54.8"
      id="archimate-oval-circle-icon"
      data-label="Oval Circle"
      fill={NEGATIVE_FILL}
      stroke="currentColor"
      strokeWidth="10"
    >
      <ellipse
        transform="scale(0.22, 0.28) translate(50, 130)"
        ry="80"
        rx="200"
        cy="70"
        cx="170"
      ></ellipse>
    </svg>

    <svg
      viewBox="0.54 18.11 96.79 69.73"
      id="archimate-cloud-icon"
      data-label="Cloud"
      fill={NEGATIVE_FILL}
      stroke="currentColor"
      strokeWidth="10"
    >
      <path
        transform="translate(5, 35) scale(0.25, 0.25) translate(-194, -301)"
        d="M 220,332.36 C 170,272.36 240,242.36 280,272.36 C 290,242.36 350,252.36 360,272.36 C 390,252.36 480,252.36 480,272.36 C 540,252.36 560,332.36 520,352.36 C 560,352.36 540.67,407.98 520,432.36 C 520,512.36 440,492.36 400,472.36 C 360,492.36 200,512.36 240,452.36 C 180,452.36 190,332.36 220,332.36 z"
      ></path>
    </svg>

    <svg
      viewBox="-104 -104 250 250"
      id="archimate-and-icon"
      data-label="Junction (And)"
    >
      <circle
        fill="currentColor"
        strokeWidth="3"
        stroke="currentColor"
        r="20"
        cy="22"
        cx="22"
        height="200"
        width="200"
      ></circle>
    </svg>

    <svg
      viewBox="-104 -104 250 250"
      id="archimate-or-icon"
      data-label="Junction (Or)"
    >
      <circle
        fill="white"
        strokeWidth="3"
        stroke="currentColor"
        r="20"
        cy="22"
        cx="22"
        height="200"
        width="200"
      ></circle>
    </svg>
  </>
);

export { ArchimateIcons };

